// extracted by mini-css-extract-plugin
export default {"expensesDetailed":"styles_expensesDetailed__IAL4A","categoriesList":"styles_categoriesList__pJUE6","list__item":"styles_list__item__Kcylk"};